export default "__VITE_ASSET__BVL$rP9j__"